import { AstraSwitch } from '~/astra'
import { useStore } from '~/store/store'

export const ShowOnlyAvailableWaitingListToggle = () => {
    const showOnlyAvailable = useStore(state => state.surgeonScheduler.showOnlyAvailableWaitingListPatients)
    const toggleShowOnlyAvailable = useStore(state => state.surgeonScheduler.actions.toggleOnlyAvailableWaitingListPatients)

    return (
        <label className="flex cursor-pointer items-center gap-x-2 py-2">
            <AstraSwitch checked={showOnlyAvailable} onCheckedChange={toggleShowOnlyAvailable} />
            <span>Vis kun tilgjengelige pasienter</span>
        </label>
    )
}
